import React, { useState } from "react";
import { EaseDrawer } from "../../../../libs/EaseDrawer";
import { Alert, Badge, Button, Descriptions, Input, Popconfirm } from "antd";
import { Text1, Text3, Text4, Text5 } from "../../../../styles";
import { EditVendorProfileModal } from "../../../Common/VendorPayouts/Modals/Vendor/edit_vendor_profile_modal";
import { VENDOR_STATUS } from "../../../../constants";
import { Approvals } from "../../../../models/vendorPayouts";
import { alertify, handleApiExceptions } from "../../../../app_methods";
import { updateCurrentUserAction } from "../../../../redux/actions";
import { connect } from "react-redux";
import { PermissionHoc } from "../../../HOC";

const VendorDetailsDrawerRdx = (props) => {

  const vendor = props.vendor || {};
  const vendor_profile = vendor.vendor_profile || {};
  const dynamic_profile = vendor.dynamic_profile || [];
  const vendor_approval_status = vendor.status || {}.status;
  const vendor_approval = new Approvals(vendor.approval || {});
  const [showVendorModal, setshowVendorModal] = useState(false);
  const [showAllBene, setShowAllBene] = useState(false);
  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  const [rejectReason, setRejectReason] = useState("");

  const PermissableButton = PermissionHoc(Button, "", { is_component: true, fallbackComponent: null })

  const renderTitle = () => {
    return (
      <div className="mb-4">
        <Text1 className="d-block" strong>Vendor Details</Text1>
        <Text5 copyable>{vendor.id}</Text5>
      </div>
    )
  };

  const renderBasicDetails = () => {
    return (
      <div className="mt-4">
        <Text3 className="d-block" strong>Basic Details</Text3>
        <Descriptions className='mt-2' title={false} column={1} bordered size="small">
          <Descriptions.Item label="Vendor Name">{vendor.name}</Descriptions.Item>
          <Descriptions.Item label="Email Id">{vendor.email}</Descriptions.Item>
          <Descriptions.Item label="Phone Number">{vendor.phone}</Descriptions.Item>
          {vendor.status_label ? (
            <Descriptions.Item label="Status"><Badge color={VENDOR_STATUS[vendor.status_label].color} text={<Text4>{VENDOR_STATUS[vendor.status_label].label || "---"}</Text4>} /></Descriptions.Item>
          ) : null

          }

          {
            vendor.created_by ? (
              <Descriptions.Item label="Created By">{(vendor.created_by || {}).name || '---'}</Descriptions.Item>
            ) : null
          }
        </Descriptions>
      </div>
    )
  }

  const renderBankDetailsBasic = () => {
    const bankDetails = (vendor_profile.vendor_bank_details || []);
    const bankDetailsFirst = bankDetails[0];
    if (!bankDetailsFirst) return null;
    return (
      <div className="mt-4">
        <div className="d-flex align-items-center justify-content-between">
          <Text3 className="d-block" strong>Bank Accounts</Text3>
          {bankDetails[1] ? <PermissableButton onClick={() => setShowAllBene(!showAllBene)} type="link" className="pr-0">{showAllBene ? 'Hide' : 'Show All'}</PermissableButton> : null}
        </div>
        <Descriptions className="mt-2" title={false} column={1} bordered size="small">
          <Descriptions.Item label="Account Name">{bankDetailsFirst.name_on_bank}</Descriptions.Item>
          <Descriptions.Item label="Account Number">{bankDetailsFirst.account_number}</Descriptions.Item>
          <Descriptions.Item label="IFSC">{bankDetailsFirst.account_ifsc}</Descriptions.Item>
        </Descriptions>
      </div>
    )
  }

  const renderBankDetailsAll = () => {
    let bankDetails = ([...vendor_profile.vendor_bank_details || []]);
    bankDetails.splice(0, 1);
    if (!showAllBene) return null;
    return bankDetails.map((element) => {
      return (
        <>
          <Descriptions className="mt-2" title={false} column={1} bordered size="small">
            <Descriptions.Item label="Account Name">{element.name_on_bank}</Descriptions.Item>
            <Descriptions.Item label="Account Number">{element.account_number}</Descriptions.Item>
            <Descriptions.Item label="IFSC">{element.account_ifsc}</Descriptions.Item>
          </Descriptions>
        </>
      )
    })
  }

  const renderProfileDetails = () => {
    if (!dynamic_profile || dynamic_profile.length === 0) return null;
    return (
      <div className="mt-4">
        <div className="d-flex align-items-center justify-content-between">
          <Text3 className="d-block" strong> Profile Details </Text3>
          {
            vendor.allow_dynamic_profile_edit && (((vendor.approval || {}).id && vendor.status_label === "unapproved") || (!((vendor.approval || {}).id) && vendor.status_label === "active")) ? (
              <PermissableButton required_permission="VENDOR_WRITE" type="primary" size="small" onClick={() => toggleVendorModal()} >Edit Profile</PermissableButton>
            ) : null
          }
        </div>
        <Descriptions className="mt-2" title={false} column={1} bordered size="small">
          {dynamic_profile.map((item, index) => <Descriptions.Item key={index} label={item.label}>{item.value || "---"}</Descriptions.Item>)}
        </Descriptions>
      </div>
    )
  }

  const alertColor = (vendor_approval) => {
    if (!((vendor_approval.approver || {}).name) && !(vendor_approval.rejecter || {}).name) {
      return "warning";
    } else if (vendor_approval.status === "approved") {
      return "success";
    } else if (vendor_approval.status === "rejected") {
      return "error";
    } else return "info"
  }

  const renderApprovalDetails = () => {
    if (!vendor_approval || !vendor_approval.id) return null;
    return (
      <div className="mt-4">
        <div className="d-flex align-items-center justify-content-between">
          <Text3 className="d-block" strong>Approval</Text3>
          {
            props.current_user.user.role > 1 ? (
              <div>
                <PermissableButton required_permission="VENDOR_WRITE" loading={isApproving} disabled={["approved", "rejected"].includes(vendor_approval.status) || (props.current_user.user.role === 2 && vendor_approval.status === "checked")} type="primary" size="small" className="mr-1" onClick={() => approval_action("APPROVE")} >Approve</PermissableButton>
                <Popconfirm placement="bottom" title={
                  <div>
                    <Text4 strong>Reject Reason:</Text4>
                    <Input value={rejectReason} onChange={(e) => setRejectReason(e.target.value)} />
                  </div>
                } okText="Reject" okType="danger" onConfirm={() => approval_action("REJECT")}>
                  <PermissableButton required_permission="VENDOR_WRITE" loading={isRejecting} disabled={["approved", "rejected"].includes(vendor_approval.status) || (props.current_user.user.role === 2 && vendor_approval.status === "checked")} type="danger" size="small" bordered>Reject</PermissableButton>
                </Popconfirm>
              </div>
            ) : null
          }
        </div>
        <Descriptions className='mt-2' title={false} column={1} bordered size="small">
          <Descriptions.Item label="Maker">{vendor_approval.maker.name || "---"}</Descriptions.Item>
          <Descriptions.Item label="Checker">{vendor_approval.checker.name || "---"}</Descriptions.Item>
          {/* <Descriptions.Item label="Approver">
            {vendor.status_label === "rejected" ? vendor_approval.rejecter.name : vendor.status_label === "active" ? vendor_approval.approver.name : "---"}
          </Descriptions.Item> */}
        </Descriptions>
        {
          Object.keys(vendor_approval).length > 1 ? (
            <Alert type={alertColor(vendor_approval)} className="mt-2" message={
              <>
                {!((vendor_approval.approver || {}).name) && !((vendor_approval.rejecter || {}).name) ? <Text4>Waiting for Approval.</Text4> : <Text4>Vendor <strong>{vendor_approval.status}</strong> by {vendor_approval.rejecter.name || vendor_approval.approver.name}.</Text4>}
                {
                  vendor_approval.status === "rejected" && vendor_approval.reject_reason ? <>
                    <br />
                    <Text5>Reason: <i>{vendor_approval.reject_reason}</i></Text5>
                  </> : null
                }

              </>
            } />
          ) : null
        }
      </div>
    )
  }

  const approval_action = async (action_type) => {
    if (rejectReason && !/^\s*([0-9a-zA-Z\ \.]*)\s*$/.test(rejectReason)) {
      alertify("Error", "Only alphanumeric values are allowed in reject reason.", "error");
      return;
    }
    setIsApproving(true);
    setIsRejecting(true);
    const response = await vendor_approval.approval_update({ action_type: action_type, reject_reason: rejectReason });
    if (!response.success) {
      setIsApproving(false);
      setIsRejecting(false);
      handleApiExceptions(response);
      setRejectReason("");
      return;
    }
    setRejectReason("");
    setIsApproving(false);
    setIsRejecting(false);
    alertify("Success", response.data.message, "success");
    props.fetchList();
  };

  const toggleVendorModal = () => {
    setshowVendorModal(!showVendorModal);
  }

  const onVendorSave = () => {
    toggleVendorModal();
    props.fetchList();
  }
  console.log(props.current_user.user)
  return (

    <>
      <EaseDrawer
        className="payout-link-details-drawer"
        visible={props.visible}
        onClose={props.onClose}
        hideHeader
        hideFooter
        width={525}
      >
        <div className="mt-3">
          {renderTitle()}
          {renderBasicDetails()}
          {renderBankDetailsBasic()}
          {renderBankDetailsAll()}
          {renderProfileDetails()}
          {renderApprovalDetails()}
        </div>
      </EaseDrawer>

      <EditVendorProfileModal
        visible={showVendorModal}
        toggleVendorModal={() => toggleVendorModal()}
        vendor={vendor}
        onVendorSave={onVendorSave}
      />
    </>
  )
};

const mapStateToProps = (state) => ({
  current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
  updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

const VendorDetailsDrawer = connect(mapStateToProps, mapDispatchToProps)(VendorDetailsDrawerRdx)
export { VendorDetailsDrawer };